import React from 'react';

export const Line = ({corner1, corner2, thickness, color}) => (
    <g>
        <line
            x1={corner1.x}
            y1={corner1.y}
            x2={corner2.x}
            y2={corner2.y}
            stroke={color}
            strokeWidth={thickness}
        />
    </g>
);


export const Valve = ({rect, color, trans}) => {
    //x:5000, y:2000
    let polyA = (rect.x - 6) + ' ' + (rect.y + 28);
    let polyB = (rect.x + 15) + ' ' + (rect.y + 35);
    let polyC = (rect.x - 6) + ' ' + (rect.y + 43);

    let polyA_2 = (rect.x + 36) + ' ' + (rect.y + 28);
    let polyB_2 = (rect.x + 15) + ' ' + (rect.y + 35);
    let polyC_2 = (rect.x + 36) + ' ' + (rect.y + 43);
    return (
        <g>


            <rect x={rect.x} y={rect.y} width="30" height="20" fill={color}/>
            <line
                x1={rect.x + 15}
                y1={rect.y + 20}
                x2={rect.x + 15}
                y2={rect.y + 35}
                stroke={color}
                strokeWidth={2}
                fill={color}
            />
            <polygon
                points={polyA + ',' + polyB + ',' + polyC}
                fill={color}
                stroke={color}
            />
            <polygon
                points={polyA_2 + ',' + polyB_2 + ',' + polyC_2}
                fill={color}
                stroke={color}
            />
        </g>
    )
};


export const ValveVertical = ({rect, color, trans}) => {
    //x:5000, y:2000
    let polyA = (rect.x + 29) + ' ' + (rect.y - 5);
    let polyB = (rect.x + 35) + ' ' + (rect.y + 15);
    let polyC = (rect.x + 42) + ' ' + (rect.y - 5);

    let polyA_2 = (rect.x + 29) + ' ' + (rect.y + 35);
    let polyB_2 = (rect.x + 35) + ' ' + (rect.y + 15);
    let polyC_2 = (rect.x + 42) + ' ' + (rect.y + 35);
    return (
        <g>


            <rect x={rect.x} y={rect.y} width="20" height="30" fill={color}/>
            <line
                x1={rect.x + 20}
                y1={rect.y + 15}
                x2={rect.x + 35}
                y2={rect.y + 15}
                stroke={color}
                strokeWidth={2}
                fill={color}
            />
            <polygon
                points={polyA + ',' + polyB + ',' + polyC}
                fill={color}
                stroke={color}
            />
            <polygon
                points={polyA_2 + ',' + polyB_2 + ',' + polyC_2}
                fill={color}
                stroke={color}
            />
        </g>
    )
};

export const Hex = ({rect, color, text, type}) => {
    let M = "M" + rect.x + " " + (rect.y + 15);
    let L0 = "L" + (rect.x + 50) + " " + (rect.y + 15);
    let L1 = "L" + (rect.x + 60) + " " + (rect.y + 20);
    let L2 = "L" + (rect.x + 70) + " " + (rect.y + 10);
    let L3 = "L" + (rect.x + 80) + " " + (rect.y + 15);
    let L_end = "L" + (rect.x + 120) + " " + (rect.y + 15);

    let M_b = "M" + rect.x + " " + (rect.y + 55);
    let L0_b = "L" + (rect.x + 50) + " " + (rect.y + 55);
    let L1_b = "L" + (rect.x + 60) + " " + (rect.y + 60);
    let L2_b = "L" + (rect.x + 70) + " " + (rect.y + 50);
    let L3_b = "L" + (rect.x + 80) + " " + (rect.y + 55);
    let L_end_b = "L" + (rect.x + 120) + " " + (rect.y + 55);


    let M_V = "M" + (rect.x + 30) + " " + (rect.y);
    let L0_V = "L" + (rect.x + 30) + " " + (rect.y + 25);
    let L1_V = "L" + (rect.x + 20) + " " + (rect.y + 30);
    let L2_V = "L" + (rect.x + 40) + " " + (rect.y + 40);
    let L3_V = "L" + (rect.x + 30) + " " + (rect.y + 45);
    let L_end_V = "L" + (rect.x + 30) + " " + (rect.y + 70);

    let M_b_V = "M" + (rect.x + 90) + " " + (rect.y);
    let L0_b_V = "L" + (rect.x + 90) + " " + (rect.y + 25);
    let L1_b_V = "L" + (rect.x + 80) + " " + (rect.y + 30);
    let L2_b_V = "L" + (rect.x + 100) + " " + (rect.y + 40);
    let L3_b_V = "L" + (rect.x + 90) + " " + (rect.y + 45);
    let L_end_b_V = "L" + (rect.x + 90) + " " + (rect.y + 70);

    return (
        <>
            {type === 'horizontal' ?
                <g>
                    <rect x={rect.x} y={rect.y} width="120" height="70" stroke='yellow' stroke-width={2} fill={color}/>
                    <text x={rect.x + 60} y={rect.y + 35} font-size={15} dominant-baseline="middle"
                          text-anchor="middle" fill='yellow'>{text}</text>
                    <path d={M + ' ' + L0 + ' ' + L1 + ' ' + L2 + ' ' + L3 + ' ' + L_end} stroke="yellow"
                          strokeWidth={2} fill='none'/>
                    <path d={M_b + ' ' + L0_b + ' ' + L1_b + ' ' + L2_b + ' ' + L3_b + ' ' + L_end_b} stroke="yellow"
                          strokeWidth={2} fill='none'/>
                </g> :
                <g>
                    <rect x={rect.x} y={rect.y} width="120" height="70" stroke='yellow' stroke-width={2} fill={color}/>
                    <text x={rect.x + 60} y={rect.y + 35} font-size={12} dominant-baseline="middle"
                          text-anchor="middle" fill='yellow'>{text}</text>
                    <path d={M_V + ' ' + L0_V + ' ' + L1_V + ' ' + L2_V + ' ' + L3_V + ' ' + L_end_V} stroke="yellow"
                          strokeWidth={2} fill='none'/>
                    <path d={M_b_V + ' ' + L0_b_V + ' ' + L1_b_V + ' ' + L2_b_V + ' ' + L3_b_V + ' ' + L_end_b_V} stroke="yellow"
                          strokeWidth={2} fill='none'/>
                </g>
            }
        </>

    )
};

export const Hex_small = ({rect, text}) => {
    let M = "M" + rect.x + " " + (rect.y + 10);
    let L0 = "L" + (rect.x + 7.5) + " " + (rect.y + 7);
    let L1 = "L" + (rect.x + 15) + " " + (rect.y + 13);
    let L2 = "L" + (rect.x + 22.5) + " " + (rect.y + 7);
    let L3 = "L" + (rect.x + 30) + " " + (rect.y + 13);
    let L4 = "L" + (rect.x + 37.5) + " " + (rect.y + 7);
    let L5 = "L" + (rect.x + 45) + " " + (rect.y + 13);
    let L6 = "L" + (rect.x + 52.5) + " " + (rect.y + 7);
    let L_end = "L" + (rect.x + 60) + " " + (rect.y + 13);

    return (

        <g>
            <rect x={rect.x} y={rect.y} width="60" height="20" stroke='yellow' stroke-width={1} fill='#0000d8'/>
            <path d={M + ' ' + L0 + ' ' + L1 + ' ' + L2 + ' ' + L3 + ' ' + L4 + ' ' + L5 + ' ' + L6 + ' ' + L_end}
                  stroke="yellow" strokeWidth={1} fill='none'/>
            {text !== '' ?
                <text x={rect.x + 30} y={rect.y + 30} font-size={18} fontWeight='bold' dominant-baseline="middle"
                      text-anchor="middle" fill='#add8e6'>{text}</text>
                : ''
            }
        </g>

    )
};

export const Tank = ({rect, color, text}) => (
    <g>
        <rect x={rect.x} y={rect.y} rx='5' ry='5' width="120" height="30" stroke='yellow' stroke-width={2}
              fill='#30D5C8'/>
        <rect x={rect.x + 100} y={rect.y - 20} rx='5' ry='5' width="15" height="20" fill='#30D5C8'stroke='yellow' stroke-width={2} />
        <rect x={rect.x} y={rect.y + 30} rx='5' ry='5' width="120" height="60" stroke='yellow' stroke-width={2}
              fill={color}/>
        <text x={rect.x + 60} y={rect.y + 30 + 30} font-size={15} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='white'>{text}</text>
    </g>

);

export const TankH2 = ({rect, color, text}) => (
    <g>
        <rect x={rect.x} y={rect.y} rx='5' ry='5' width="120" height="30" stroke='yellow' stroke-width={2}
              fill='white'/>
        <rect x={rect.x} y={rect.y + 30} rx='5' ry='5' width="120" height="40" stroke='yellow' stroke-width={2}
              fill={color}/>
        <text x={rect.x + 60} y={rect.y + 30 + 20} font-size={15} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='white'>{text}</text>
    </g>

);

export const Acc = ({rect, color, text}) => (
    <g>
        <rect x={rect.x} y={rect.y} rx='5' ry='5' width="120" height="30" stroke='yellow' stroke-width={2}
              fill='#30D5C8'/>
        <rect x={rect.x} y={rect.y + 30} rx='5' ry='5' width="120" height="30" stroke='yellow' stroke-width={2}
              fill={color}/>
        <text x={rect.x + 60} y={rect.y + 30 + 15} font-size={15} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='yellow'>{text}</text>
    </g>

);

export const AccH2  = ({rect, color, text}) => (
    <g>
        <rect x={rect.x} y={rect.y} rx='5' ry='5' width="100" height="60" stroke='yellow' stroke-width={2}
              fill='#9979b8'/>
        <text x={rect.x + 50} y={rect.y + 30} font-size={15} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='yellow'>{text}</text>
    </g>

);


export const Anode_Cathode = ({rect}) => (
    <g>
        <rect x={rect.x} y={rect.y} width="700" height="175" stroke='yellow' stroke-width={5} fill='red'/>
        <text x={rect.x + 350} y={rect.y + 87.5} font-size={100} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='white'>ANODE
        </text>
        <rect x={rect.x} y={rect.y + 175} width="700" height="175" stroke='yellow' stroke-width={5} fill='green'/>
        <text x={rect.x + 350} y={rect.y + 262.5} font-size={100} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='black'>CATHODE
        </text>
        <rect x={rect.x} y={rect.y + 350} width="700" height="175" stroke='yellow' stroke-width={5} fill='#4b8bc8'/>
        <text x={rect.x + 350} y={rect.y + 437.5} font-size={100} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='white'>COOLERS
        </text>

    </g>

);

export const AnodeCathodeH2 = ({rect}) => (
    <g>
        <rect x={rect.x} y={rect.y} width="120" height="20" stroke='yellow' stroke-width={2} fill='red'/>
        <text x={rect.x + 60} y={rect.y + 10} font-size={20} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='white'>ANODE
        </text>
        <rect x={rect.x} y={rect.y + 20} width="120" height="20" stroke='yellow' stroke-width={2} fill='green'/>
        <text x={rect.x + 60} y={rect.y + 30} font-size={20} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='black'>CATHODE
        </text>
        <rect x={rect.x} y={rect.y + 40} width="120" height="20" stroke='yellow' stroke-width={2} fill='#4b8bc8'/>
        <text x={rect.x + 60} y={rect.y + 50} font-size={20} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='white'>COOLERS
        </text>

    </g>

);

export const Acr = ({rect, text}) => (
    <g>
        <rect x={rect.x} y={rect.y} width="120" height="40" stroke='green' stroke-width={2} fill='grey'/>
        <text x={rect.x + 60} y={rect.y + 20} font-size={20} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='white'>{text}
        </text>

    </g>

);

export const TwoPolygon = ({rect}) => {

    let polyA = (rect.x - 20) + ' ' + (rect.y - 10);
    let polyB = rect.x + ' ' + rect.y;
    let polyC = (rect.x - 20) + ' ' + (rect.y + 10);
    let polyA_2 = (rect.x + 20) + ' ' + (rect.y - 10);
    let polyB_2 = rect.x + ' ' + rect.y;
    let polyC_2 = (rect.x + 20) + ' ' + (rect.y + 10);
    return (
        <g>
            <polygon
                points={polyA + ',' + polyB + ',' + polyC}
                fill='grey'
                stroke='grey'
            />
            <polygon
                points={polyA_2 + ',' + polyB_2 + ',' + polyC_2}
                fill='grey'
                stroke='grey'
            />

        </g>
    )
};


export const PumpRight = ({circle, color}) => {
    let polyA = circle.cx + ' ' + circle.cy;
    let polyB = (circle.cx - 20) + ' ' + (circle.cy + 20);
    let polyC = (circle.cx + 20) + ' ' + (circle.cy + 20);
    return (
        <g>


            <circle cx={circle.cx} cy={circle.cy} r={circle.r} fill={color}/>
            <polygon
                points={polyA + ',' + polyB + ',' + polyC}
                fill={color}
                stroke={color}
            />
            <rect x={circle.cx - 1} y={circle.cy - circle.r} width="23" height="8" fill={color}/>

        </g>
    )
};

export const PumpLeft = ({circle, color}) => {
    let polyA = circle.cx + ' ' + circle.cy;
    let polyB = (circle.cx - 20) + ' ' + (circle.cy + 20);
    let polyC = (circle.cx + 20) + ' ' + (circle.cy + 20);
    return (
        <g>
            <rect x={circle.cx - 23} y={circle.cy - circle.r} width="23" height="8" fill={color} stroke='black'/>
            <polygon
                points={polyA + ',' + polyB + ',' + polyC}
                fill={color}
                stroke='black'
            />
            <circle cx={circle.cx} cy={circle.cy} r={circle.r} fill={color} stroke='black'/>
        </g>
    )
};

export const Ejector = ({rect, color, stroke}) => {
    let polyA = (rect.x + 40) + ' ' + (rect.y + 15);
    let polyB = (rect.x + 60) + ' ' + (rect.y - 5);
    let polyC = (rect.x + 60) + ' ' + (rect.y + 35);
    return (
        <g>

            <polygon
                points={polyA + ',' + polyB + ',' + polyC}
                fill={color}
                stroke={stroke}
                strokeWidth={3}
            />
            <rect x={rect.x} y={rect.y} width="40" height="30" fill={color} stroke={stroke} strokeWidth={3}/>
        </g>
    )
};

export const FAN800 = ({rect, color}) => {

    return (
        <g>
            <rect x={rect.x} y={rect.y} width="40" height="20" fill={color} stroke='blue' strokeWidth={2}/>
            <rect x={rect.x} y={rect.y + 20} width="40" height="15" fill='none' stroke='blue' strokeWidth={2}/>
        </g>
    )
};

export const REF = ({rect, color}) => {

    return (
        <g>
            <circle cx={rect.cx} cy={rect.cy} r={40} fill='yellow' />
            <rect x={rect.cx - 40} y={rect.cy} width="80" height="60" fill='yellow'/>
            <circle cx={rect.cx} cy={rect.cy + 30} r={30} fill='orange' />
            <rect x={rect.cx - 30} y={rect.cy + 30} width="60" height="30" fill='orange'/>
            <rect x={rect.cx - 25} y={rect.cy + 50} width="50" height="10" fill='red'/>
            <text x={rect.cx - 40 + 100} y={rect.cy + 25} font-size={20} fontWeight='bold' dominant-baseline="middle"
                  text-anchor="middle" fill='white'>REF
            </text>


        </g>
    )
};

export const Ejector_Left = ({rect, color, stroke}) => {

    let polyA = (rect.x) + ' ' + (rect.y + 10);
    let polyB = (rect.x - 15) + ' ' + (rect.y - 2);
    let polyC = (rect.x - 15) + ' ' + (rect.y + 22);
    return (
        <g>

            <polygon
                points={polyA + ',' + polyB + ',' + polyC}
                fill={color}
                stroke={stroke}
                strokeWidth={3}
            />
            <rect x={rect.x} y={rect.y} width="30" height="20" fill={color} stroke={stroke} strokeWidth={3}/>
        </g>
    )
};

export const CSA = ({rect}) => (
    <g>
        <rect x={rect.x} y={rect.y} width="40" height="80" stroke='yellow' stroke-width={2} fill='red'/>
        <text x={rect.x + 20} y={rect.y + 40} font-size={20} dominant-baseline="middle" text-anchor="middle"
              fill='black'>A
        </text>
        <rect x={rect.x + 40} y={rect.y} width="80" height="80" stroke='yellow' stroke-width={2} fill='#4b8bc8'/>
        <rect x={rect.x + 120} y={rect.y} width="40" height="80" stroke='yellow' stroke-width={2} fill='green'/>
        <text x={rect.x + 140} y={rect.y + 40} font-size={20} dominant-baseline="middle" text-anchor="middle"
              fill='black'>C
        </text>
        <text x={rect.x + 80} y={rect.y + 40} font-size={20} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='white'>CSA
        </text>

    </g>

);

export const CSA_Vertical = ({rect}) => (
    <g>
        <rect x={rect.x} y={rect.y} width="80" height="30" stroke='yellow' stroke-width={2} fill='red'/>
        <rect x={rect.x} y={rect.y + 30} width="80" height="60" stroke='yellow' stroke-width={2} fill='green'/>
        <rect x={rect.x} y={rect.y + 90} width="80" height="30" stroke='yellow' stroke-width={2} fill='#4b8bc8'/>
        <text x={rect.x + 40} y={rect.y + 60} font-size={20} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='black'>CSA
        </text>

    </g>

);

export const ILS = ({rect}) => (
    <g>
        <rect x={rect.x} y={rect.y} width="20" height="70" stroke='blue' stroke-width={2} fill='red'/>
        <rect x={rect.x + 20} y={rect.y} width="30" height="70" stroke='blue' stroke-width={2} fill='#4b8bc8'/>
        <rect x={rect.x + 50} y={rect.y} width="20" height="70" stroke='blue' stroke-width={2} fill='red'/>
        <text x={rect.x + 85} y={rect.y + 5} font-size={20} fontWeight='bold' dominant-baseline="middle"
              text-anchor="middle" fill='red'>ILS
        </text>

    </g>

);


export const Valve_3_Way = ({rect, color}) => {

    // x:5000, y:2000   => 3000 4000
    let polyA = (rect.x - 6) + ' ' + (rect.y + 28);
    let polyB = (rect.x + 15) + ' ' + (rect.y + 35);
    let polyC = (rect.x - 6) + ' ' + (rect.y + 43);

    let polyA_2 = (rect.x + 36) + ' ' + (rect.y + 28);
    let polyB_2 = (rect.x + 15) + ' ' + (rect.y + 35);
    let polyC_2 = (rect.x + 36) + ' ' + (rect.y + 43);


    let polyA_3 = (rect.x + 15) + ' ' + (rect.y + 35);
    let polyB_3 = (rect.x + 15 - 12) + ' ' + (rect.y + 50);
    let polyC_3 = (rect.x + 15 + 12) + ' ' + (rect.y + 50);

    return (
        <g>


            <rect x={rect.x} y={rect.y} width="30" height="20" fill={color}/>
            <line
                x1={rect.x + 15}
                y1={rect.y + 20}
                x2={rect.x + 15}
                y2={rect.y + 35}
                stroke={color}
                strokeWidth={2}
                fill={color}
            />
            <polygon
                points={polyA + ',' + polyB + ',' + polyC}
                fill={color}
                stroke={color}
            />
            <polygon
                points={polyA_2 + ',' + polyB_2 + ',' + polyC_2}
                fill={color}
                stroke={color}
            />
            <polygon
                points={polyA_3 + ',' + polyB_3 + ',' + polyC_3}
                fill={color}
                stroke={color}
            />
        </g>
    )
};

export const Valve3WayInverted = ({rect, color}) => {

    // x:5000, y:2000   => 3000 4000
    let polyA = (rect.x - 6) + ' ' + (rect.y - 10);
    let polyB = (rect.x + 15) + ' ' + (rect.y - 20);
    let polyC = (rect.x - 6) + ' ' + (rect.y - 30);

    let polyA_2 = (rect.x + 36) + ' ' + (rect.y - 10);
    let polyB_2 = (rect.x + 15) + ' ' + (rect.y - 20);
    let polyC_2 = (rect.x + 36) + ' ' + (rect.y - 30);


    let polyA_3 = (rect.x + 15) + ' ' + (rect.y - 20);
    let polyB_3 = (rect.x + 15 - 12) + ' ' + (rect.y - 40);
    let polyC_3 = (rect.x + 15 + 12) + ' ' + (rect.y - 40);

    return (
        <g>


            <rect x={rect.x} y={rect.y} width="30" height="20" fill={color}/>
            <line
                x1={rect.x + 15}
                y1={rect.y}
                x2={rect.x + 15}
                y2={rect.y - 20}
                stroke={color}
                strokeWidth={2}
                fill={color}
            />
            <polygon
                points={polyA + ',' + polyB + ',' + polyC}
                fill={color}
                stroke={color}
            />
            <polygon
                points={polyA_2 + ',' + polyB_2 + ',' + polyC_2}
                fill={color}
                stroke={color}
            />
            <polygon
                points={polyA_3 + ',' + polyB_3 + ',' + polyC_3}
                fill={color}
                stroke={color}
            />
        </g>
    )
};

export const Temp = ({rect, color}) => {
    let polyA = (rect.x + 20) + ' ' + (rect.y + 7.5);
    let polyB = (rect.x + 50) + ' ' + (rect.y - 5);
    let polyC = (rect.x + 50) + ' ' + (rect.y + 20);

    let polyA_2 = (rect.x + 30) + ' ' + (rect.y + 7.5);
    let polyB_2 = (rect.x - 10) + ' ' + (rect.y - 5);
    let polyC_2 = (rect.x - 10) + ' ' + (rect.y + 20);


    return (
        <g>
            <rect x={rect.x} y={rect.y} width="40" height="15" fill={color} strokeWidth={2}/>
            <polygon
                points={polyA + ',' + polyB + ',' + polyC}
                fill={color}
            />
            <polygon
                points={polyA_2 + ',' + polyB_2 + ',' + polyC_2}
                fill={color}
            />
        </g>
    )
};

export const ARD304 = ({rect}) => {


    return (
        <g>

            <rect x={rect.x} y={rect.y} width="150" height="40" fill='#30D5C8' stroke='yellow' strokeWidth={2}/>
            <rect x={rect.x + 120} y={rect.y - 30} width="30" height="30" fill='#30D5C8' stroke='yellow' strokeWidth={2}/>
            <text x={rect.x + 75} y={rect.y + 20} font-size={18}  fontWeight='bold' dominant-baseline="middle"
                  text-anchor="middle" fill='yellow'>ARD304</text>
        </g>
    )
};


export const ParallelLines = ({lineA, lineB}) => {
    return (
        <g>


            <line
                x1={lineA.x1}
                y1={lineA.y1}
                x2={lineA.x2}
                y2={lineA.y2}
                stroke='white'
                strokeWidth={3}
                fill='white'
            />

            <line
                x1={lineB.x1}
                y1={lineB.y1}
                x2={lineB.x2}
                y2={lineB.y2}
                stroke='white'
                strokeWidth={3}
                fill='white'
            />

        </g>
    )
};

export const ParallelLinesStroke = ({lineA, lineB,stroke}) => {
    return (
        <g>


            <line
                x1={lineA.x1}
                y1={lineA.y1}
                x2={lineA.x2}
                y2={lineA.y2}
                stroke={stroke}
                strokeWidth={3}
                fill={stroke}
            />

            <line
                x1={lineB.x1}
                y1={lineB.y1}
                x2={lineB.x2}
                y2={lineB.y2}
                stroke={stroke}
                strokeWidth={3}
                fill={stroke}
            />

        </g>
    )
};


export const Coil2 = ({rect}) => {
    return (
        <g>
            <clipPath id="cut-off-bottom-4">
                <rect x={rect.cx - 8} y={rect.cy - 8 - 1} width={8 * 2} height={8} />
            </clipPath>
            <clipPath id="cut-off-bottom-5">
                <rect x={rect.cx + 8} y={rect.cy - 8 - 1} width={8 * 2} height={8} />
            </clipPath>
            <clipPath id="cut-off-bottom-6">
                <rect x={rect.cx + 16 + 8} y={rect.cy - 8 - 1} width={8 * 2} height={8} />
            </clipPath>
            <circle cx={rect.cx} cy={rect.cy} r={8} fill='none' stroke='white' strokeWidth={3} clipPath="url(#cut-off-bottom-4)" />
            <circle cx={rect.cx + 16} cy={rect.cy} r={8} fill='none' stroke='white' strokeWidth={3} clipPath="url(#cut-off-bottom-5)"  />
            <circle cx={rect.cx + 16 + 16} cy={rect.cy} r={8} fill='none' stroke='white' strokeWidth={3} clipPath="url(#cut-off-bottom-6)"  />
        </g>
    )
};

export const Coil = ({rect}) => {
    return (
        <g>
            <clipPath id="cut-off-bottom-1">
                <rect x={rect.cx - 8} y={rect.cy - 8 - 1} width={8 * 2} height={8} />
            </clipPath>
            <clipPath id="cut-off-bottom-2">
                <rect x={rect.cx + 8} y={rect.cy - 8 - 1} width={8 * 2} height={8} />
            </clipPath>
            <clipPath id="cut-off-bottom-3">
                <rect x={rect.cx + 16 + 8} y={rect.cy - 8 - 1} width={8 * 2} height={8} />
            </clipPath>
            <circle cx={rect.cx} cy={rect.cy} r={8} fill='none' stroke='white' strokeWidth={3} clipPath="url(#cut-off-bottom-1)"  />
            <circle cx={rect.cx + 16} cy="145" r="8" fill='none' stroke='white' strokeWidth={3} clipPath="url(#cut-off-bottom-2)"  />
            <circle cx={rect.cx + 16 + 16} cy="145" r="8" fill='none' stroke='white' strokeWidth={3} clipPath="url(#cut-off-bottom-3)"  />
        </g>
    )
};

export const Breaker2 = ({rect}) => {
        return (
            <g>
                <clipPath id="cut-off-bottom-breaker-2">
                    <rect x={rect.cx} y={rect.cy - 15 - 1} width={15 * 2} height={15} />
                </clipPath>
                <circle cx={rect.cx} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 30} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 15} cy={rect.cy} r={15} fill='none' stroke='white' strokeWidth={1} clipPath="url(#cut-off-bottom-breaker-2)"  />
            </g>
        )
    }


export const Breaker = ({rect}) => {
    if(rect.type === 'inv'){
        return (
            <g>
                <clipPath id="cut-off-bottom-breaker-1">
                    <rect x={rect.cx} y={rect.cy - 15 - 1} width={15 * 2} height={15} />
                </clipPath>
                <circle cx={rect.cx} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 30} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 15} cy={rect.cy} r={15} fill='none' stroke='white' strokeWidth={1} clipPath="url(#cut-off-bottom-breaker-1)"  />
            </g>
        )
    }
    else if(rect.type === 'grid'){
        return (
            <g>
                <clipPath id="cut-off-bottom-grid-1">
                    <rect x={rect.cx} y={rect.cy - 15 - 1} width={15 * 2} height={15} />
                </clipPath>
                <circle cx={rect.cx} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 30} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 15} cy={rect.cy} r={15} fill='none' stroke='white' strokeWidth={1} clipPath="url(#cut-off-bottom-grid-1)"  />
            </g>
        )
    }
    else if(rect.type === 'mcb002'){
        return (
            <g>
                <clipPath id="cut-off-bottom-mcb002-1">
                    <rect x={rect.cx} y={rect.cy - 15 - 1} width={15 * 2} height={15} />
                </clipPath>
                <circle cx={rect.cx} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 30} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 15} cy={rect.cy} r={15} fill='none' stroke='white' strokeWidth={1} clipPath="url(#cut-off-bottom-mcb002-1)"  />
            </g>
        )
    } else if(rect.type === 'mccb1'){
        return (
            <g>
                <clipPath id="cut-off-bottom-mccb1-1">
                    <rect x={rect.cx} y={rect.cy - 15 - 1} width={15 * 2} height={15} />
                </clipPath>
                <circle cx={rect.cx} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 30} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 15} cy={rect.cy} r={15} fill='none' stroke='white' strokeWidth={1} clipPath="url(#cut-off-bottom-mccb1-1)"  />
            </g>
        )
    } else if(rect.type === 'ats1'){
        return (
            <g>
                <clipPath id="cut-off-bottom-ats1-1">
                    <rect x={rect.cx} y={rect.cy - 15 - 1} width={15 * 2} height={15} />
                </clipPath>
                <circle cx={rect.cx} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 30} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 15} cy={rect.cy} r={15} fill='none' stroke='white' strokeWidth={1} clipPath="url(#cut-off-bottom-ats1-1)"  />
            </g>
        )
    } else if(rect.type === 'ats2'){
        return (
            <g>
                <clipPath id="cut-off-bottom-ats2-1">
                    <rect x={rect.cx} y={rect.cy - 15 - 1} width={15 * 2} height={15} />
                </clipPath>
                <circle cx={rect.cx} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 30} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 15} cy={rect.cy} r={15} fill='none' stroke='white' strokeWidth={1} clipPath="url(#cut-off-bottom-ats2-1)"  />
            </g>
        )
    } else if(rect.type === 'mds1'){
        return (
            <g>
                <clipPath id="cut-off-bottom-mds1-1">
                    <rect x={rect.cx} y={rect.cy - 15 - 1} width={15 * 2} height={15} />
                </clipPath>
                <circle cx={rect.cx} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 30} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 15} cy={rect.cy} r={15} fill='none' stroke='white' strokeWidth={1} clipPath="url(#cut-off-bottom-mds1-1)"  />
            </g>
        )
    } else if(rect.type === 'mccb2'){
        return (
            <g>
                <clipPath id="cut-off-bottom-mccb2-1">
                    <rect x={rect.cx - 15 - 1} y={rect.cy} width={15} height={15 * 2} />
                </clipPath>
                <circle cx={rect.cx} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx} cy={rect.cy+30} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx} cy={rect.cy + 15} r={15} fill='none' stroke='white' strokeWidth={1} clipPath="url(#cut-off-bottom-mccb2-1)"  />
            </g>
        )
    } else if(rect.type === 'mccb3'){
        return (
            <g>
                <clipPath id="cut-off-bottom-mccb3-1">
                    <rect x={rect.cx + 15 - 10} y={rect.cy} width={15} height={15 * 2} />
                </clipPath>
                <circle cx={rect.cx} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx} cy={rect.cy+30} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx} cy={rect.cy + 15} r={15} fill='none' stroke='white' strokeWidth={1} clipPath="url(#cut-off-bottom-mccb3-1)"  />
            </g>
        )
    }
    
    else {
        return (
            <g>
                <clipPath id="cut-off-bottom-load-1">
                    <rect x={rect.cx} y={rect.cy - 15 - 1} width={15 * 2} height={15} />
                </clipPath>
                <circle cx={rect.cx} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 30} cy={rect.cy} r={4} fill='none' stroke='white' strokeWidth={1} />
                <circle cx={rect.cx + 15} cy={rect.cy} r={15} fill='none' stroke='white' strokeWidth={1} clipPath="url(#cut-off-bottom-load-1)"  />
            </g>
        )
    }

};

export const CircuitInside = ({lineA, lineB, color}) => {
    return (
        <g>
            <path d="M 880, 250 L 890, 240 L 890, 230 L 890, 235 L 920, 235 L 920, 245 L 930, 245 L 910, 245 L 920, 245 L 910, 255" stroke={color} strokeWidth={2} fill='none'/>
            <path d="M 880, 260 L 890, 270 L 890, 280 L 890, 275 L 920, 275 L 920, 265 L 910, 265 L 930, 265 L 920, 245" stroke={color} strokeWidth={2} fill='none'/>
            <path d="M 880, 255 L 860, 255" stroke={color} strokeWidth={2} fill='none'/>
            <line
                x1={lineA.x1}
                y1={lineA.y1}
                x2={lineA.x2}
                y2={lineA.y2}
                stroke={color}
                strokeWidth={3}
                fill={color}
            />

            <line
                x1={lineB.x1}
                y1={lineB.y1}
                x2={lineB.x2}
                y2={lineB.y2}
                stroke={color}
                strokeWidth={3}
                fill={color}
            />
        </g>
    )
};

export const CircuitInsideFSW = ({lineA, lineB, color}) => {
    return (
        <g>
            <path d="M 285, 80 L 295, 70 L 295, 60 L 295, 65 L 325, 65 L 325, 75 L 330, 75 L 315, 75 L 325, 75 L 315, 95" stroke={color} strokeWidth={2} fill='none'/>
            <path d="M 285, 90 L 295, 100 L 295, 110 L 295, 105 L 325, 105 L 325, 95 L 315, 95 L 335, 95 L 325, 75" stroke={color} strokeWidth={2} fill='none'/>
            <path d="M 285, 85 L 265, 85" stroke={color} strokeWidth={2} fill='none'/>
            <line
                x1={lineA.x1}
                y1={lineA.y1}
                x2={lineA.x2}
                y2={lineA.y2}
                stroke={color}
                strokeWidth={3}
                fill={color}
            />

            <line
                x1={lineB.x1}
                y1={lineB.y1}
                x2={lineB.x2}
                y2={lineB.y2}
                stroke={color}
                strokeWidth={3}
                fill={color}
            />
        </g>
    )
};

export const Fan_Animate = ({cx, cy, color, toAnimate}) => {
    var M = "M" + " " + cx + " " + cy;
    var R1 = "L" + (cx - 22 ) + " " + (cy) + " " + "L" + (cx -22) + " " + (cy - 5) + " " + "L" + (cx) + " " + (cy -5);
    var R2 = "L" + (cx) + " " + (cy - 22) + " " + "L" + (cx + 5) + " " + (cy - 22) + " " + "L" + (cx + 5) + " " + (cy);
    var R3 = "L" + (cx + 22) + " " + (cy) + " " + "L" + (cx + 22) + " " + (cy + 5) + " " + "L" + (cx) + " " + (cy + 5);
    var R4 = "L" + (cx) + " " + (cy + 22) + " " + "L" + (cx - 5) + " " + (cy + 22) + " " + "L" + (cx - 5) + " " + (cy);
    var from = "00 " + cx + " " + cy;
    var to = "360 " + cx + " " + cy;

    if(toAnimate === 'true'){
        return (
            <g>

                <circle cx={cx} cy={cy} r={15} fill={color}/>
                <path  d={M + ' ' + R1 + ' ' + M + ' ' + R2 + ' ' + M + ' ' + R3 + ' ' + M + ' ' + R4} fill={color} stroke={color} strokeWidth={2}>
                    <animateTransform attributeName="transform"
                                      attributeType="XML"
                                      type="rotate"
                                      from={from}
                                      to={to}
                                      dur="3s"
                                      repeatCount="indefinite"/>

                </path>
            </g>
        )
    }
    else {
        return (
            <g>
                <circle cx={cx} cy={cy} r={15} fill={color}/>
                <path  d={M + ' ' + R1 + ' ' + M + ' ' + R2 + ' ' + M + ' ' + R3 + ' ' + M + ' ' + R4} fill={color} stroke={color} strokeWidth={2}>
                </path>
            </g>
        )
    }

};


// update 230328 SOFC ****************************************************************
export const MIX = ({rect, text}) => {
    return (
        <g>
            <rect x={rect.x} y={rect.y} width="80" height="50" stroke='#003192' stroke-width={2} fill='#9999ff'/>
            
            {text !== '' ?
                <text x={rect.x + 40} y={rect.y + 30} font-size={15} fontWeight='bold' dominant-baseline="middle"
                      text-anchor="middle" fill='white'>{text}</text>
                : ''
            }
        </g>

    )
}

export const HEX_SOFC = ({rect, color, text, type}) => {
    // horizontal
    let M = "M" + rect.x + " " + (rect.y + 15);
    let L0 = "L" + (rect.x + 0) + " " + (rect.y + 15);
    let L1 = "L" + (rect.x + 10) + " " + (rect.y + 20);
    let L2 = "L" + (rect.x + 20) + " " + (rect.y + 10);
    let L3 = "L" + (rect.x + 30) + " " + (rect.y + 15);
    let L_end = "L" + (rect.x + 40) + " " + (rect.y + 15);

    let M_b = "M" + rect.x + " " + (rect.y + 65); 
    let L0_b = "L" + (rect.x + 0) + " " + (rect.y + 65);
    let L1_b = "L" + (rect.x + 10) + " " + (rect.y + 70);
    let L2_b = "L" + (rect.x + 20) + " " + (rect.y + 60);
    let L3_b = "L" + (rect.x + 30) + " " + (rect.y + 65);
    let L_end_b = "L" + (rect.x + 40) + " " + (rect.y + 65);

    // vertical
    let M_V = "M" + (rect.x + 20) + " " + (rect.y);
    let L0_V = "L" + (rect.x + 20) + " " + (rect.y + 40);
    let L1_V = "L" + (rect.x + 15) + " " + (rect.y + 45);
    let L2_V = "L" + (rect.x + 25) + " " + (rect.y + 55);
    let L3_V = "L" + (rect.x + 20) + " " + (rect.y + 60);
    let L_end_V = "L" + (rect.x + 20) + " " + (rect.y + 100);

    let M_b_V = "M" + (rect.x + 90) + " " + (rect.y);
    let L0_b_V = "L" + (rect.x + 90) + " " + (rect.y + 25);
    let L1_b_V = "L" + (rect.x + 80) + " " + (rect.y + 30);
    let L2_b_V = "L" + (rect.x + 100) + " " + (rect.y + 40);
    let L3_b_V = "L" + (rect.x + 90) + " " + (rect.y + 45);
    let L_end_b_V = "L" + (rect.x + 90) + " " + (rect.y + 70);

    return (
        <>
            {type === 'horizontal' ?
                <g>
                    <rect x={rect.x} y={rect.y} width="40" height="80" stroke='yellow' stroke-width={2} fill='#0000d8'/>
                    <text x={rect.x + 20} y={rect.y + 92} font-size={15} dominant-baseline="middle"
                          text-anchor="middle" fill='#add8e6' fontWeight='bold'>{text}</text>
                    <path d={M + ' ' + L0 + ' ' + L1 + ' ' + L2 + ' ' + L3 + ' ' + L_end} stroke="yellow"
                          strokeWidth={2} fill='none'/>
                    <path d={M_b + ' ' + L0_b + ' ' + L1_b + ' ' + L2_b + ' ' + L3_b + ' ' + L_end_b} stroke="yellow"
                          strokeWidth={2} fill='none'/>
                </g> :
                <g>
                    <rect x={rect.x} y={rect.y} width="40" height="100" stroke='yellow' stroke-width={2} fill='#0000d8'/>
                    <text x={rect.x + 20} y={rect.y + 110} font-size={15} dominant-baseline="middle" fontWeight='bold'
                          text-anchor="middle" fill='#add8e6'>{text}</text>
                    <path d={M_V + ' ' + L0_V + ' ' + L1_V + ' ' + L2_V + ' ' + L3_V + ' ' + L_end_V} stroke="yellow"
                          strokeWidth={2} fill='none'/>

                </g>
            }
        </>

    )
}

export const HEX_SOFC_small = ({rect, color, text, type}) => {
    // horizontal
    let M = "M" + rect.x + " " + (rect.y + 20);
    let L0 = "L" + (rect.x + 0) + " " + (rect.y + 20);
    let L1 = "L" + (rect.x + 10) + " " + (rect.y + 25);
    let L2 = "L" + (rect.x + 20) + " " + (rect.y + 15);
    let L3 = "L" + (rect.x + 30) + " " + (rect.y + 25);
    let L4 = "L" + (rect.x + 40) + " " + (rect.y + 15);
    let L5 = "L" + (rect.x + 50) + " " + (rect.y + 25);
    let L6 = "L" + (rect.x + 60) + " " + (rect.y + 15);
    let L_end = "L" + (rect.x + 40) + " " + (rect.y + 25);

    let M_b = "M" + rect.x + " " + (rect.y + 75); 
    let L0_b = "L" + (rect.x + 0) + " " + (rect.y + 75);
    let L1_b = "L" + (rect.x + 10) + " " + (rect.y + 80);
    let L2_b = "L" + (rect.x + 20) + " " + (rect.y + 70);
    let L3_b = "L" + (rect.x + 30) + " " + (rect.y + 75);
    let L_end_b = "L" + (rect.x + 40) + " " + (rect.y + 75);

    // vertical
    let M_V = "M" + (rect.x + 30) + " " + (rect.y);
    let L0_V = "L" + (rect.x + 30) + " " + (rect.y + 25);
    let L1_V = "L" + (rect.x + 20) + " " + (rect.y + 30);
    let L2_V = "L" + (rect.x + 40) + " " + (rect.y + 40);
    let L3_V = "L" + (rect.x + 30) + " " + (rect.y + 45);
    let L_end_V = "L" + (rect.x + 30) + " " + (rect.y + 70);

    let M_b_V = "M" + (rect.x + 90) + " " + (rect.y);
    let L0_b_V = "L" + (rect.x + 90) + " " + (rect.y + 25);
    let L1_b_V = "L" + (rect.x + 80) + " " + (rect.y + 30);
    let L2_b_V = "L" + (rect.x + 100) + " " + (rect.y + 40);
    let L3_b_V = "L" + (rect.x + 90) + " " + (rect.y + 45);
    let L_end_b_V = "L" + (rect.x + 90) + " " + (rect.y + 70);

    return (
        <>
            {type === 'horizontal' ?
                <g>
                    <rect x={rect.x} y={rect.y} width="60" height="40" stroke='yellow' stroke-width={2} fill='#0000d8'/>
                    <text x={rect.x + 30} y={rect.y + 53} font-size={15} dominant-baseline="middle"
                          text-anchor="middle" fill='#add8e6' fontWeight='bold'>{text}</text>
                    <path d={M + ' ' + L0 + ' ' + L1 + ' ' + L2 + ' ' + L3 + ' ' + L4 + ' ' + L5 + ' ' + L6} stroke="yellow"
                          strokeWidth={2} fill='none'/>
                    {/* <path d={M_b + ' ' + L0_b + ' ' + L1_b + ' ' + L2_b + ' ' + L3_b + ' ' + L_end_b} stroke="yellow"
                          strokeWidth={2} fill='none'/> */}
                </g> :
                <g>
                    <rect x={rect.x} y={rect.y} width="120" height="70" stroke='yellow' stroke-width={2} fill={color}/>
                    <text x={rect.x + 60} y={rect.y + 35} font-size={12} dominant-baseline="middle"
                          text-anchor="middle" fill='yellow'>{text}</text>
                    <path d={M_V + ' ' + L0_V + ' ' + L1_V + ' ' + L2_V + ' ' + L3_V + ' ' + L_end_V} stroke="yellow"
                          strokeWidth={2} fill='none'/>
                    <path d={M_b_V + ' ' + L0_b_V + ' ' + L1_b_V + ' ' + L2_b_V + ' ' + L3_b_V + ' ' + L_end_b_V} stroke="yellow"
                          strokeWidth={2} fill='none'/>
                </g>
            }
        </>

    )
}

export const HEX_SOFC_small_TS = ({rect, text}) => {
    let M = "M" + rect.x + " " + (rect.y + 20);
    let L0 = "L" + (rect.x + 7.5) + " " + (rect.y + 17);
    let L1 = "L" + (rect.x + 15) + " " + (rect.y + 23);
    let L2 = "L" + (rect.x + 22.5) + " " + (rect.y + 17);
    let L3 = "L" + (rect.x + 30) + " " + (rect.y + 23);
    let L4 = "L" + (rect.x + 37.5) + " " + (rect.y + 17);
    let L5 = "L" + (rect.x + 45) + " " + (rect.y + 23);
    let L6 = "L" + (rect.x + 52.5) + " " + (rect.y + 17);
    let L_end = "L" + (rect.x + 60) + " " + (rect.y + 23);

    return (

        <g>
            <rect x={rect.x} y={rect.y} width="60" height="40" stroke='#92d050' stroke-width={2} fill='#7f7f7f'/>
            <path d={M + ' ' + L0 + ' ' + L1 + ' ' + L2 + ' ' + L3 + ' ' + L4 + ' ' + L5 + ' ' + L6 + ' ' + L_end}
                  stroke="#92d050" strokeWidth={2} fill='none'/>
            {text !== '' ?
                <text x={rect.x + 30} y={rect.y + 50} font-size={18} fontWeight='bold' dominant-baseline="middle"
                      text-anchor="middle" fill='aliceblue'>{text}</text>
                : ''
            }
        </g>

    )
};

export const ATO = ({rect, text}) => {
    return (
        <g>
            <rect x={rect.x} y={rect.y} width="80" height="30" stroke='#003192' stroke-width={2} fill='gray'/>
            
            {text !== '' ?
                <text x={rect.x + 40} y={rect.y + 17} font-size={15} fontWeight='bold' dominant-baseline="middle"
                      text-anchor="middle" fill='white'>{text}</text>
                : ''
            }
        </g>

    )   
}  

export const Stack_SOFC = ({rect, text, color}) => {
    return (
        <g>
            <rect x={rect.x} y={rect.y} width="110" height="30" stroke='yellow' stroke-width={2}
                fill='#C00000'/>
            <text x={rect.x + 50} y={rect.y + 15} font-size={20}  dominant-baseline="middle"
                text-anchor="middle" fill='black'>A</text>
            <rect x={rect.x} y={rect.y + 30} width="110" height="30" stroke='yellow' stroke-width={2}
                fill='green'/>
            <text x={rect.x + 50} y={rect.y + 30 + 15} font-size={20} dominant-baseline="middle"
                text-anchor="middle" fill='black'>C</text>
    </g>
    )
}

export const TestStand = ({rect}) => {
    return (
        <g>
            <rect x={rect.x} y={rect.y} width="80" height="70" stroke='#4b8bc8' stroke-width={2} fill='gray'/>
            <text x={rect.x + 37} y={rect.y + 15} font-size={15} dominant-baseline="middle"
                text-anchor="middle" fill='skyblue' fontWeight='bold'>STEAM</text>
            <text x={rect.x + 40} y={rect.y + 60} font-size={15} dominant-baseline="middle"
                text-anchor="middle" fill='yellow' fontWeight='bold'>EXHAUST</text>

            <text x={rect.x + 37} y={rect.y + 90} font-size={15} dominant-baseline="middle"
                text-anchor="middle" fill='#D5D5D5' fontWeight='bold'>PSM TEST STAND</text>
        </g>
    )

}

export const MFC = ({rect, text, color}) => {
    return (
        <g>
            <rect x={rect.x} y={rect.y} width="35" height="35" stroke='#003192' stroke-width={2}
                fill='gray'/>
            <rect x={rect.x - 7.5} y={rect.y + 35} width="50" height="15" stroke='#003192' stroke-width={2}
                fill='gray'/>
           
        </g>
    )
}

export const Filter = ({rect, text}) => {
    return (
        <g>
            <rect x={rect.x} y={rect.y} width="80" height="30" stroke='#BFBFBF' stroke-width={2} fill='green'/>
            
            {text !== '' ?
                <text x={rect.x + 115} y={rect.y + 15} font-size={15} fontWeight='bold' dominant-baseline="middle"
                      text-anchor="middle" fill='white'>{text}</text>
                : ''
            }
        </g>
 
    )
}

export const FilterTextVertical = ({rect, text}) => {
    return (
        <g>
            <rect x={rect.x} y={rect.y} width="80" height="30" stroke='#BFBFBF' stroke-width={2} fill='green'/>
            
            {text !== '' ?
                <text x={rect.x + 38} y={rect.y + 40} font-size={15} fontWeight='bold' dominant-baseline="middle"
                      text-anchor="middle" fill='white'>{text}</text>
                : ''
            }
        </g>
 
    )
}

export const CLD_close = ({rect, color, text, type}) => {
    
    let M_V = "M" + (rect.x + 45) + " " + rect.y;
    let L0_V = "L" + rect.x  + " " + rect.y;
    let L1_V = "L" + rect.x  + " " + (rect.y + 10);

    let M_b_V = "M" + (rect.x + 45) + " " + (rect.y);
    let L0_b_V = "L" + (rect.x + 45) + " " + (rect.y + 10);
    let L1_b_V = "L" + (rect.x + 35) + " " + (rect.y + 15);
    let L2_b_V = "L" + (rect.x + 55) + " " + (rect.y + 20);
    let L3_b_V = "L" + (rect.x + 45) + " " + (rect.y + 25);
    let L4_b_V = "L" + (rect.x + 35) + " " + (rect.y + 30);
    let L5_b_V = "L" + (rect.x + 55) + " " + (rect.y + 35);
    let L6_b_V = "L" + (rect.x + 45) + " " + (rect.y + 40);
    let L7_b_V = "L" + (rect.x + 35) + " " + (rect.y + 45);
    let L8_b_V = "L" + (rect.x + 55) + " " + (rect.y + 50);
    let L9_b_V = "L" + (rect.x + 45) + " " + (rect.y + 55);
    let L_end_b_V = "L" + (rect.x + 45) + " " + (rect.y + 65);

    let M_c_V = "M" + (rect.x + 45) + " " + (rect.y + 65);
    let L0_c_V = "L" + rect.x  + " " + (rect.y + 65);
    let L1_c_V = "L" + rect.x  + " " + (rect.y + 55);

    let M_d_V = "M" + rect.x + " " + (rect.y + 17);
    let L0_d_V = "L" + rect.x  + " " + (rect.y + 47);

    return (
            <g>
                <path d={M_V + ' ' + L0_V + ' ' + L1_V  } stroke="white" strokeWidth={1} fill='none'/>
                <circle cx={rect.x} cy={rect.y + 13} r={4} fill='none' stroke='white' strokeWidth={1} />
                <path d={M_b_V + ' ' + L0_b_V + ' ' + L1_b_V + ' ' + L2_b_V + ' ' + L3_b_V + ' ' + L4_b_V + ' ' + L5_b_V + ' ' + L6_b_V + ' '
                    + L7_b_V + ' ' + L8_b_V + ' ' + L9_b_V + ' ' + L_end_b_V} stroke="white"
                    strokeWidth={1} fill='none'/>
                <path d={M_c_V + ' ' + L0_c_V + ' ' + L1_c_V  } stroke="white" strokeWidth={1} fill='none'/>
                <circle cx={rect.x} cy={rect.y + 51} r={4} fill='none' stroke='white' strokeWidth={1} />
                <path d={M_d_V + ' ' + L0_d_V  } stroke="white" strokeWidth={1} fill='none'/>
            </g>
    )
};

export const Heater = ({rect, color, text, type}) => {

    let M_V = "M" + (rect.x + 45) + " " + rect.y;

    let M_V_start = "M" + (rect.x + 75) + " " + (rect.y);
    let L0_b_start = "L" + (rect.x + 45) + " " + (rect.y);

    let M_V_bottom = "M" + (rect.x + 75) + " " + (rect.y + 65);
    let L0_b_bottom = "L" + (rect.x + 45) + " " + (rect.y + 65);

    let M_b_V = "M" + (rect.x + 45) + " " + (rect.y);
    let L0_b_V = "L" + (rect.x + 45) + " " + (rect.y + 10);
    let L1_b_V = "L" + (rect.x + 35) + " " + (rect.y + 15);
    let L2_b_V = "L" + (rect.x + 55) + " " + (rect.y + 20);
    let L3_b_V = "L" + (rect.x + 45) + " " + (rect.y + 25);
    let L4_b_V = "L" + (rect.x + 35) + " " + (rect.y + 30);
    let L5_b_V = "L" + (rect.x + 55) + " " + (rect.y + 35);
    let L6_b_V = "L" + (rect.x + 45) + " " + (rect.y + 40);
    let L7_b_V = "L" + (rect.x + 35) + " " + (rect.y + 45);
    let L8_b_V = "L" + (rect.x + 55) + " " + (rect.y + 50);
    let L9_b_V = "L" + (rect.x + 45) + " " + (rect.y + 55);
    let L_end_b_V = "L" + (rect.x + 45) + " " + (rect.y + 65);

    let M_c_V = "M" + (rect.x + 45) + " " + (rect.y + 65);
    let L0_c_V = "L" + rect.x  + " " + (rect.y + 65);
    let L1_c_V = "L" + rect.x  + " " + (rect.y + 55);

    let M_d_V = "M" + rect.x + " " + (rect.y + 17);
    let L0_d_V = "L" + (rect.x - 75)  + " " + (rect.y + 47);

    return (
        <g>
            <circle cx={rect.x + 80} cy={rect.y} r={4} fill='none' stroke='#00FF00' strokeWidth={1} />
            <path d={M_b_V + ' ' + L0_b_V + ' ' + L1_b_V + ' ' + L2_b_V + ' ' + L3_b_V + ' ' + L4_b_V + ' ' + L5_b_V + ' ' + L6_b_V + ' '
                + L7_b_V + ' ' + L8_b_V + ' ' + L9_b_V + ' ' + L_end_b_V} stroke="#00FF00"
                  strokeWidth={1} fill='none'/>
            <path d={M_V_start + ' ' + L0_b_start  } stroke="#00FF00" strokeWidth={1} fill='none'/>
            <circle cx={rect.x + 80} cy={rect.y + 65} r={4} fill='none' stroke='#00FF00' strokeWidth={1} />
            <path d={M_V_bottom + ' ' + L0_b_bottom  } stroke="#00FF00" strokeWidth={1} fill='none'/>

            <text x={rect.x} y={rect.y + 50} font-size={15} dominant-baseline="middle" text-anchor="middle" fill='white' fontWeight='500' >{text}</text>
        </g>
    )
};

export const CLD_open = ({rect, color, text, type}) => {
    
    let M_V = "M" + (rect.x + 45) + " " + rect.y;
    let L0_V = "L" + rect.x  + " " + rect.y;
    let L1_V = "L" + rect.x  + " " + (rect.y + 10);

    let M_b_V = "M" + (rect.x + 45) + " " + (rect.y);
    let L0_b_V = "L" + (rect.x + 45) + " " + (rect.y + 10);
    let L1_b_V = "L" + (rect.x + 35) + " " + (rect.y + 15);
    let L2_b_V = "L" + (rect.x + 55) + " " + (rect.y + 20);
    let L3_b_V = "L" + (rect.x + 45) + " " + (rect.y + 25);
    let L4_b_V = "L" + (rect.x + 35) + " " + (rect.y + 30);
    let L5_b_V = "L" + (rect.x + 55) + " " + (rect.y + 35);
    let L6_b_V = "L" + (rect.x + 45) + " " + (rect.y + 40);
    let L7_b_V = "L" + (rect.x + 35) + " " + (rect.y + 45);
    let L8_b_V = "L" + (rect.x + 55) + " " + (rect.y + 50);
    let L9_b_V = "L" + (rect.x + 45) + " " + (rect.y + 55);
    let L_end_b_V = "L" + (rect.x + 45) + " " + (rect.y + 65);

    let M_c_V = "M" + (rect.x + 45) + " " + (rect.y + 65);
    let L0_c_V = "L" + rect.x  + " " + (rect.y + 65);
    let L1_c_V = "L" + rect.x  + " " + (rect.y + 55);

    let M_d_V = "M" + rect.x + " " + (rect.y + 17);
    let L0_d_V = "L" + (rect.x - 15)  + " " + (rect.y + 47);

    return (
            <g>
                <path d={M_V + ' ' + L0_V + ' ' + L1_V  } stroke="white" strokeWidth={1} fill='none'/>
                <circle cx={rect.x} cy={rect.y + 13} r={4} fill='none' stroke='white' strokeWidth={1} />
                <path d={M_b_V + ' ' + L0_b_V + ' ' + L1_b_V + ' ' + L2_b_V + ' ' + L3_b_V + ' ' + L4_b_V + ' ' + L5_b_V + ' ' + L6_b_V + ' '
                    + L7_b_V + ' ' + L8_b_V + ' ' + L9_b_V + ' ' + L_end_b_V} stroke="white"
                    strokeWidth={1} fill='none'/>
                <path d={M_c_V + ' ' + L0_c_V + ' ' + L1_c_V  } stroke="white" strokeWidth={1} fill='none'/>
                <circle cx={rect.x} cy={rect.y + 51} r={4} fill='none' stroke='white' strokeWidth={1} />
                <path d={M_d_V + ' ' + L0_d_V  } stroke="white" strokeWidth={1} fill='none'/>
            </g>
    )
}; 

export const PSMStack = ({rect, color, text1, temp, volt, tempColor, voltColor}) => {
    return (  
            <g>
                <rect x={rect.x} y={rect.y} rx="10" ry="10" width="120" height="70"  stroke-width={2} fill={color} />
                <text x={rect.x+ 60} y={rect.y + 15} font-size={17} dominant-baseline="middle" text-anchor="middle" fill='yellow' fontWeight='bold'>{text1}</text>
                <text x={rect.x+ 60} y={rect.y + 35} font-size={15} dominant-baseline="middle" text-anchor="middle" fill={tempColor} fontWeight='500' >{temp} ℃</text>
                <text x={rect.x+ 60} y={rect.y + 55} font-size={15} dominant-baseline="middle" text-anchor="middle" fill={voltColor} fontWeight='500' >{volt} V</text>
            </g>
    )
};

export const ResLoad = ({rect, color, text, type}) => {
    let M = "M" + rect.x + " " + (rect.y + 15);
    let L0 = "L" + (rect.x + 50) + " " + (rect.y + 15);
    let L1 = "L" + (rect.x + 60) + " " + (rect.y + 20);
    let L2 = "L" + (rect.x + 70) + " " + (rect.y + 10);
    let L3 = "L" + (rect.x + 80) + " " + (rect.y + 15);
    let L_end = "L" + (rect.x + 120) + " " + (rect.y + 15);

    let M_b = "M" + rect.x + " " + (rect.y + 55);
    let L0_b = "L" + (rect.x + 50) + " " + (rect.y + 55);
    let L1_b = "L" + (rect.x + 60) + " " + (rect.y + 60);
    let L2_b = "L" + (rect.x + 70) + " " + (rect.y + 50);
    let L3_b = "L" + (rect.x + 80) + " " + (rect.y + 55);
    let L_end_b = "L" + (rect.x + 120) + " " + (rect.y + 55);


    let M_V = "M" + (rect.x + 30) + " " + (rect.y);
    let L0_V = "L" + (rect.x + 30) + " " + (rect.y + 40);
    let L1_V = "L" + (rect.x + 20) + " " + (rect.y + 45);
    let L2_V = "L" + (rect.x + 40) + " " + (rect.y + 50);
    let L3_V = "L" + (rect.x + 20) + " " + (rect.y + 55);
    let L4_V = "L" + (rect.x + 40) + " " + (rect.y + 60);
    let L5_V = "L" + (rect.x + 20) + " " + (rect.y + 65);
    let L6_V = "L" + (rect.x + 40) + " " + (rect.y + 70);
    let L7_V = "L" + (rect.x + 30) + " " + (rect.y + 75);
    let L_end_V = "L" + (rect.x + 30) + " " + (rect.y + 120);

    let M_b_V = "M" + (rect.x + 60) + " " + (rect.y);
    let L0_b_V = "L" + (rect.x + 60) + " " + (rect.y + 40);
    let L1_b_V = "L" + (rect.x + 50) + " " + (rect.y + 45);
    let L2_b_V = "L" + (rect.x + 70) + " " + (rect.y + 50);
    let L3_b_V = "L" + (rect.x + 50) + " " + (rect.y + 55);
    let L4_b_V = "L" + (rect.x + 70) + " " + (rect.y + 60);
    let L5_b_V = "L" + (rect.x + 50) + " " + (rect.y + 65);
    let L6_b_V = "L" + (rect.x + 70) + " " + (rect.y + 70);
    let L7_b_V = "L" + (rect.x + 60) + " " + (rect.y + 75);
    let L_end_b_V = "L" + (rect.x + 60) + " " + (rect.y + 120);

    let M_c_V = "M" + (rect.x + 90) + " " + (rect.y);
    let L0_c_V = "L" + (rect.x + 90) + " " + (rect.y + 40);
    let L1_c_V = "L" + (rect.x + 80) + " " + (rect.y + 45);
    let L2_c_V = "L" + (rect.x + 100) + " " + (rect.y + 50);
    let L3_c_V = "L" + (rect.x + 80) + " " + (rect.y + 55);
    let L4_c_V = "L" + (rect.x + 100) + " " + (rect.y + 60);
    let L5_c_V = "L" + (rect.x + 80) + " " + (rect.y + 65);
    let L6_c_V = "L" + (rect.x + 100) + " " + (rect.y + 70);
    let L7_c_V = "L" + (rect.x + 90) + " " + (rect.y + 75);
    let L_end_c_V = "L" + (rect.x + 90) + " " + (rect.y + 120);


    return (
        <>
            {type === 'horizontal' ?
                <g>
                    <rect x={rect.x} y={rect.y} width="120" height="70" stroke='yellow' stroke-width={2} fill={color}/>
                    <text x={rect.x + 60} y={rect.y + 35} font-size={15} dominant-baseline="middle"
                          text-anchor="middle" fill='yellow'>{text}</text>
                    <path d={M + ' ' + L0 + ' ' + L1 + ' ' + L2 + ' ' + L3 + ' ' + L_end} stroke="yellow"
                          strokeWidth={2} fill='none'/>
                    <path d={M_b + ' ' + L0_b + ' ' + L1_b + ' ' + L2_b + ' ' + L3_b + ' ' + L_end_b} stroke="yellow"
                          strokeWidth={2} fill='none'/>
                </g> :
                <g>
                    <rect x={rect.x} y={rect.y} width="120" height="120" stroke='white' stroke-width={2} fill={color}/>
                    <text x={rect.x + 60} y={rect.y + 35} font-size={12} dominant-baseline="middle"
                          text-anchor="middle" fill='yellow'>{text}</text>
                    <path d={M_V + ' ' + L0_V + ' ' + L1_V + ' ' + L2_V + ' ' + L3_V + ' ' + L4_V + ' ' + L5_V + ' '+ L6_V + ' ' + L7_V + ' ' + L_end_V} stroke="white"
                          strokeWidth={2} fill='none'/>
                    <path d={M_b_V + ' ' + L0_b_V + ' ' + L1_b_V + ' ' + L2_b_V + ' ' + L3_b_V + ' ' + L4_b_V + ' ' + L5_b_V + ' ' + L6_b_V + ' ' + L7_b_V + ' ' + L_end_b_V} stroke="white"
                          strokeWidth={2} fill='none'/>
                    <path d={M_c_V + ' ' + L0_c_V + ' ' + L1_c_V + ' ' + L2_c_V + ' ' + L3_c_V + ' ' + L4_c_V + ' ' + L5_c_V + ' ' + L6_c_V + ' ' + L7_c_V + ' ' + L_end_c_V} stroke="white"
                          strokeWidth={2} fill='none'/>
                </g>
            }
        </>

    )
};

// update 241114, S300TS 
export const DIBox = ({rect, text}) => {
    return (
        <g>
            <rect x={rect.x} y={rect.y} width="70" height="50" stroke='#00b0f0' stroke-width={2} fill='#7f7f7f'/>
            
            {text !== '' ?
                <text x={rect.x + 35} y={rect.y + 25} font-size={15}  dominant-baseline="middle"
                      text-anchor="middle" fill='white'>{text}</text>
                : ''
            }
        </g>

    )
}

export const DMP = ({rect, text, type}) => {
    return (
        <g>
            <rect x={rect.x} y={rect.y} width="30" height="80" stroke='#2f528f' stroke-width={2} fill='#bfbfbf'/>
            
            {text !== '' && type==='left'?
                <text x={rect.x - 35} y={rect.y + 25} font-size={15}  dominant-baseline="middle"
                      text-anchor="middle" fill='white'>{text}</text>
                : 
                text !== '' && type==='right'?
                <text x={rect.x + 65} y={rect.y + 25} font-size={15}  dominant-baseline="middle"
                      text-anchor="middle" fill='white'>{text}</text>
                
                :''
            }
        </g>

    )
}